/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
// import Global from './global';

'use strict';
const TabInfo = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domTab: $('.js-tab-info__button'),
	$domTabContent: $('.js-tabs-info__content-wrapper'),
	$domContent: $('.tab-info__content-box'),
	classActiveTabContent: 'tabs-info__content-wrapper--active',
	classActiveTab: 'tab-info__button--active',
	classActive: 'active',

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		this.tabs();
	},

	tabs: () => {
		TabInfo.$domTab.on('click', function() {
			const clickedTab = $(this).attr('data-tab');
			const ActiveTabContent = $(`.js-tabs-info__content-wrapper[data-content='${clickedTab}']`);

			TabInfo.$domTab.removeClass(TabInfo.classActiveTab);
			$(this).addClass(TabInfo.classActiveTab);

			ActiveTabContent.siblings('.js-tabs-info__content-wrapper').fadeOut(400, function() {
				ActiveTabContent.fadeIn(400);
			});
		});
	},
};

export default TabInfo;
